import React from "react";
import { Route, Navigate, RouteProps } from "react-router-dom";

import { APICore } from "../helpers/api/apiCore";

/**
 * Private Route forces the authorization before the route can be accessed
 * @param {*} param0
 * @returns
 */
const PrivateRoute = ({ component: Component, roles, ...rest }: any) => {
  const api = new APICore();

  if (api.isUserAuthenticated() === false) {
    // not logged in so redirect to login page with the return url
    return (
      <Navigate
        // state={from: props['path']}
        to={{
          pathname: "/auth/login2",
          // state: { from: props['path'] },
        }}
      />
    );
  }

  const loggedInUser = api.getLoggedInUser();
  const userRole = loggedInUser.role;

  // check if route is restricted by role
  if (roles && roles && !roles.includes(userRole)) {
    // No matching role found, so redirect to the unauthorized page
    return <Navigate to={{ pathname: "/unauthorized" }} />;
  }
  // authorised so return component
  return <Component {...rest} />;
};

export default PrivateRoute;
